import { FunctionComponent, useEffect, useState } from 'react'
import Title from '@/components/_custom/Title/title'
import styles from './changeEmailAccount.module.scss'
import EmailData from '../emailData'
import validator from 'validator'
import { useTranslation } from 'react-i18next'
import UserInput from '@/components/_custom/UserInput/userInput'
import { EmailUser } from '@/types/EmailHandlerType'
import ButtonText from '@/components/_custom/Buttons/ButtonText/ButtonText'
import { useLazyQuery } from '@apollo/client'
import { EMAIL_EXISTS } from '@/modules/API/software/emailHandler'
import ConfirmChangeEmailAccountDialog from './Dialog/confirmChangeEmailAccountDialog'

const ChangeEmailAccount: FunctionComponent = () => {
    const { t } = useTranslation()

    const [oldEmail, setOldEmail] = useState<string>('')
    const [oldEmailDeactivationData, setOldEmailDeactivationData] = useState<EmailUser>()

    const [newEmail, setNewEmail] = useState<string>('')
    const [newEmailDeactivationData, setNewEmailDeactivationData] = useState<EmailUser>()

    const [isConfirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false)

    const [getOldEmailExists, { loading: loadingOldEmailExist, data: dataOldEmailExists, error: errorOldEmailExists }] =
        useLazyQuery(EMAIL_EXISTS, {
            variables: {
                email: oldEmail
            }
        })

    useEffect(() => {
        if (dataOldEmailExists) {
            setOldEmailDeactivationData(dataOldEmailExists.emailExists)
        }
    }, [dataOldEmailExists])

    useEffect(() => {
        if (errorOldEmailExists) {
            setOldEmailDeactivationData(undefined)
        }
    }, [errorOldEmailExists])

    useEffect(() => {
        if (validator.isEmail(oldEmail)) getOldEmailExists()
    }, [oldEmail])

    const [getNewEmailExists, { loading: loadingNewEmailExist, data: dataNewEmailExists, error: errorNewEmailExists }] =
        useLazyQuery(EMAIL_EXISTS, {
            variables: {
                email: newEmail
            }
        })

    useEffect(() => {
        if (errorNewEmailExists) {
            setNewEmailDeactivationData(undefined)
        }
    }, [errorNewEmailExists])

    useEffect(() => {
        if (dataNewEmailExists) {
            setNewEmailDeactivationData(dataNewEmailExists.emailExists)
        }
    }, [dataNewEmailExists])

    useEffect(() => {
        if (validator.isEmail(newEmail)) getNewEmailExists()
    }, [newEmail])

    function closeDialog(): void {
        setConfirmDialogOpen(false)
        setOldEmail('')
        setNewEmail('')
        setOldEmailDeactivationData(undefined)
        setNewEmailDeactivationData(undefined)
    }

    return (
        <div className={styles.Form}>
            <Title text={t('changeEmail')} className={styles.Title} />
            <div className={styles.InputContainer}>
                <div className={styles.Input}>
                    <UserInput
                        value={oldEmail}
                        setValue={setOldEmail}
                        required={true}
                        label={t('oldEmail')}
                        className={styles.UserInput}
                    />
                    <EmailData data={oldEmailDeactivationData} loading={loadingOldEmailExist} />
                </div>
                <div className={styles.Input}>
                    <UserInput
                        value={newEmail}
                        setValue={setNewEmail}
                        required={true}
                        label={t('newEmail')}
                        className={styles.UserInput}
                    />
                    <EmailData data={newEmailDeactivationData} loading={loadingNewEmailExist} />
                </div>
                <ButtonText
                    text={t('update')}
                    onClick={() => setConfirmDialogOpen(true)}
                    className={styles.Button}
                    disabled={
                        !oldEmailDeactivationData ||
                        newEmailDeactivationData !== undefined ||
                        loadingOldEmailExist ||
                        loadingNewEmailExist ||
                        !validator.isEmail(oldEmail) ||
                        !validator.isEmail(newEmail)
                    }
                />
            </div>
            <ConfirmChangeEmailAccountDialog
                open={isConfirmDialogOpen}
                handleClose={closeDialog}
                oldEmail={oldEmail}
                newEmail={newEmail}
            />
        </div>
    )
}

export default ChangeEmailAccount
